export default [
  {
    header: 'Tasarruf Yönetimi',
  },
  {
    title: 'Endeks Yönetimi',
    icon: 'CommandIcon',
    children: [
      {
        title: 'Endeks Girişi',
        route: 'pages-blog-detail',
      },
      {
        title: 'PTF Endeks Girişi',
        route: 'pages-knowledge-base',
      },

    ],
  },
/*
  {
    title: 'Hizmetler',
    icon: 'FramerIcon',
    children: [
      {
        title: 'Enerji Etüt Projeleri',
        href: '#',
      },
      {
        title: 'GES Projeleri',
        href: '#',
      },
      {
        title: 'Otomasyonlar',
        href: '#',
      },
      {
        title: 'Enerji Kimlik Belgesi (EKB)',
        href: '#',
      },
      {
        title: 'Destek Hibe ve Teşvikler',
        href: '#',
      },
      {
        title: 'Verimlilik Arttırıcı Projeler',
        href: '#',
      },
    ],
  },
  /*
  {
    title: 'Sürdürülebilirlik',
    icon: 'FigmaIcon',
    children: [
      {
        title: 'LCA- Yaşam Döngü Analizi',
        route: 'forms-element-input',
      },
      {
        title: 'EPD-Çevresel Ürün Beyanı',
        route: 'forms-element-input-group',
      },
      {
        title: 'GRI-Sürdürülebilirlik Raporlama',
        route: 'forms-element-input-mask',
      },
      {
        title: 'CPD-Karbon Saydamlık Beyanı',
        route: 'forms-element-textarea',
      },
    ],
  },
  {
    title: 'Doğrulamalar',
    icon: 'SlackIcon',
    children: [
      {
        title: 'Çevre Sera Gazı',
        route: 'forms-element-input',
      },
      {
        title: 'ISO 14064-1 Karbon Ayak İzi',
        route: 'forms-element-input-group',
      },
      {
        title: 'ISO 14046 Su Ayak İzi',
        route: 'forms-element-input-mask',
      },
      {
        title: 'ISO 14001 Çevre Yönetim Sistemi',
        route: 'forms-element-textarea',
      },
      {
        title: 'ISO 50001 Enerji Yönetim Sistemi',
        route: 'extensions-auto-suggest',
      },
      {
        title: 'Ürün Karbon Ayak İzi Doğrulama',
        route: 'forms-element-checkbox',
      },

    ],
  },
  {
    title: 'Yenilebilir Enerji',
    icon: 'SunriseIcon',
    tagVariant: 'light-danger',
    children: [
      {
        title: 'Güneş Enerjisi Santrali Başvurusu',
        route: 'charts-apex-chart',
      },
      {
        title: 'Rüzgar Enerji Santrali Başvurusu',
        route: 'charts-chartjs',
      },
      {
        title: 'Hybrid Enerji Santrali',
        route: 'charts-echart',
      },
      {
        title: 'Biyokütle Enerji Santrali Başvurusu',
        route: 'charts-echart',
      },
    ],
  },

  {
    title: 'Uyumlar',
    icon: 'AwardIcon',
    children: [
      {
        title: 'Yeşil Mutabakat Uyumu',
        route: 'page-layout-collapsed-menu',
      },
      {
        title: 'Paris İklim Antlaşması',
        route: 'page-layout-boxed-layout',
      },
    ],
  }, */
]
